import { CustomGridColumns } from '~/components/CustomDataGrid/protocols';
import { ColumnsTable } from './ColumnsTable';

export const tableItensColumns: CustomGridColumns[] = [...ColumnsTable];
